@if (variablesToShow().length > 0) {
  <div class="variable-configuration">
    @for (variable of variablesToShow(); track variable) {
      <glxy-form-field class="variable-field">
        <glxy-label>{{ variable }}</glxy-label>
        <input
          matInput
          [formControl]="getVariableFormControl(variable)"
          [placeholder]="'AI_ASSISTANT.CONFIGURATION.VARIABLE_PLACEHOLDER' | translate: { variableName: variable }"
        />
      </glxy-form-field>
    }
  </div>
}
